export enum BonusActionTypes {
    SET_BONUS = 'bonus/setBonus',
    LOAD_BONUS = 'bonus/loadingBonus',
    FILTER_BONUS_BY_VALUE = 'bonus/filterBonusByValue',
    SORT_BONUS_BY_VALUE = 'bonus/sortBonusByValue'
}